<!--  -->
<template>
  <div>
    <div style="margin: 0px 0px 10px 0px" class="search_box">
      <el-input v-model="query.keyword" placeholder="请输入小程序名称/appid/编号" style="width:230px" />
      <el-input v-model="query.title" placeholder="请输入小程序标题" style="width:218px;" />
      <el-input v-model="query.remark" placeholder="请输入小程序备注" style="width:218px;" />
      <el-select v-model="query.onlyMe" placeholder="请选择" style="margin-left:10px">
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
    </div>
    <div class="chooser_allbox">
      <div v-for="item,index in tableData" :key="index" class="chooser_box">
        <div style="margin: 14px">
          <div style="display: flex;">
            <div style="display: flex;align-items: center;">
              <img v-if="!item.weappiconurl || item.weappiconurl == null || item.weappiconurl == ''" src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" style="width:40px;border-radius: 50%;">
              <img v-else :src="item.weappiconurl" alt="" srcset="" style="width:40px;border-radius: 50%;">
              <!-- <div class="titlew_box">{{ item.title }}</div> -->
            </div>
            <div style="font-size: 16px;margin-left: 12px;font-weight: 400;color: #1D2129;width: 220px">
              <div style="height: 16px">{{ item.des_1 }}</div>
              <div style="font-size: 13px;color: #4E5969;margin-top: 8px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{ item.title }}</div>
            </div>
          </div>

          <div class="cahrw_box">
            <img :src="item.thumburl" alt="" srcset="" style="width:auto;height: 178px;overflow: hidden">
          </div>
          <div style="color:#252525;margin: auto">
            <span style="font-size: 15px;display: flex;align-items: center;flex-wrap: wrap;margin-bottom: 10px;">
              <el-avatar :size="20" :src="item.sender_avatar" @error="errorHandler">
                <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png">
              </el-avatar><el-tag v-if="item.sender!=''" style="margin-left: 10px;"> {{ item.sender }}</el-tag>
              <div style="margin-left:10px;max-width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-size:14px;color: #1D2129">{{ item.remark }}</div>
            </span>
            <div style="margin-bottom: 10px;display: flex;justify-content: space-between;">
              <el-tag style="margin-right:10px;font-size: 14px">{{ item.type_text }}</el-tag>
              <el-tag style="font-size: 12px;background-color: #FFFFFF;border: 0;color: #86909C">{{ item.created_at_str }}</el-tag>
            </div>
            <div style="font-size: 14px;margin-top: 10px;" class="copy_box">
              <el-tag v-if="item.miniprogram_no!=''" type="success" style="color: #0FC6C2;border-radius: 2px;font-size: 14px">{{ item.miniprogram_no }}</el-tag>
              <div v-if="item.miniprogram_no!=''" class="copy_icon"><i
                v-clipboard:copy="item.miniprogram_no"
                v-clipboard:success="cowe"
                v-clipboard:error="onError"
                style="cursor: pointer;margin-left: 5px;"
                class="el-icon-document-copy"
              /></div>
            </div>
          </div>
        </div>
        <div style="position: absolute;bottom: 0;width: 100%;border-top: 1px solid #e9e9e9">
          <button v-if="item.type == 1 || item.type == 3" style="cursor: pointer;color: #165DFF;width: 100%;height: 40px;background-color: #fff;border: 0;font-size: 16px;border-radius: 6px" @click="choose(item)">选择</button>
        </div>
      </div>
    </div>

    <pagination-right
      :current-page="query.page"
      :page-sizes="[20]"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="修改小程序"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      width="30%"
    >
      <el-form label-position="right" label-width="80px" :model="itemwechat">
        <el-form-item label="标题">
          <el-input v-model="itemwechat.title" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="itemwechat.des_1" />
        </el-form-item>
        <el-form-item label="跳转路径">
          <el-input v-model="itemwechat.pagepath" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sumbit">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { miniprogramList, appletCheckMessage } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 20,
        type: 3,
        keyword: null,
        title: null,
        onlyMe: 2,
        remark: ''
      },
      accountarr: [{
        value: 1,
        label: '查看组内小程序'
      }, {
        value: 2,
        label: '我关联的小程序'
      }],
      tableData: [],
      total: null,
      itemwechat: {},
      dialogVisible: false,
      type: null,
      ids: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    cowe() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onError() {
      this.$message({
        message: '复制失败',
        type: 'error'
      })
    },
    send(item, type, ids) {
      console.log('官方', type, ids)
      this.type = type
      this.ids = ids
      this.list()
    },
    async list() {
      const data = await miniprogramList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data-----------', this.tableData)
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keyword = null
      this.query.title = null
      this.query.onlyMe = 2
      this.query.remark = null
      this.list()
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    choose(item) {
      console.log(item)
      // eslint-disable-next-line eqeqeq
      if (this.type == 2) {
        console.log('接口')
        appletCheckMessage({
          sp_message_no: this.ids,
          app_id: item.app_id
        }).then((res) => {
          this.$emit('callwechat', item)
        })
      } else {
        // this.$emit('wechatcallback', item)
        this.$emit('callwechat', item)
      }
    },
    edit(item) {
      this.dialogVisible = true
      this.itemwechat = item
    },
    sumbit() {
      if (this.itemwechat.des_1 === '') {
        this.$message({
          type: 'error',
          message: `请输入描述`
        })
        return
      }
      if (this.itemwechat.title === '') {
        this.$message({
          type: 'error',
          message: `请输入标题`
        })
        return
      }
      if (this.itemwechat.pagepath === '') {
        this.$message({
          type: 'error',
          message: `请输入跳转地址`
        })
        return
      }
      this.$emit('wechatcallback', this.itemwechat)
    },
    errorHandler() {}
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.chooser_allbox{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 900px;
  overflow-y: auto;
}
.chooser_box{
  width: 300px;
  height: 420px;
  border: 1px solid #e9e9e9;
  border-radius: 6px;
  box-sizing: border-box;
  /* margin: 0 auto; */
  margin-bottom: 20px;
  margin-right: 18px;
  position: relative;
}
.titlew_box{
  margin-left: 5px;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cahrw_box{
  margin: 14px 0;
  height: 178px;
  text-align: center;
  overflow: hidden;
}
.line{
  height: 1px;
  background-color: #e9e9e9;
  width: 100%;
  margin-top: 8px;
}
.daser{
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 222px;
  margin-top:5px;
  height: 32px;
}
.copy_box{
  display: flex;
  align-items: center;
}
</style>
